"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryDataSource = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const mobx_1 = require("mobx");
const searchOptions_1 = require("../utils/searchOptions");
const typeguards_1 = require("../utils/typeguards");
const sortOptions_1 = require("../utils/sortOptions");
class InMemoryDataSource {
    constructor(data) {
        this.data = data;
    }
    get(query) {
        if (this.cache && this.isSameQuery(query)) {
            return Promise.resolve(this.cache.result);
        }
        let result = mobx_1.isObservable(this.data)
            ? mobx_1.toJS(this.data)
            : cloneDeep_1.default(this.data);
        result = this.searchData(result, query);
        result = this.sortData(result, query);
        result = this.groupData(result, query);
        this.cache = {
            query,
            result,
        };
        return Promise.resolve(result);
    }
    groupData(data, query) {
        if (!typeguards_1.isOptionsWithGroup(data)) {
            return data;
        }
        const dataMap = new Map();
        data.forEach(({ text, value, group }) => {
            var _a, _b;
            const option = { text, value };
            if (dataMap.has(group)) {
                (_b = (_a = dataMap.get(group)) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.push(option);
            }
            else {
                dataMap.set(group, { text: String(group), value: group, options: [option] });
            }
        });
        let groupedData = Array.from(dataMap.values());
        groupedData = this.sortData(groupedData, query);
        return groupedData;
    }
    searchData(data, query) {
        if (typeof query.search !== 'string') {
            return data;
        }
        return searchOptions_1.searchOptions(data, query.search, query.enableGroupSearch);
    }
    sortData(data, query) {
        if (!query.sort) {
            return data;
        }
        return sortOptions_1.sortOptions(data, query.sort);
    }
    isSameQuery(query) {
        var _a, _b, _c;
        const isSameSearch = ((_a = this.cache) === null || _a === void 0 ? void 0 : _a.query.search) === query.search &&
            ((_b = this.cache) === null || _b === void 0 ? void 0 : _b.query.enableGroupSearch) === query.enableGroupSearch;
        const isSameSort = ((_c = this.cache) === null || _c === void 0 ? void 0 : _c.query.sort) === query.sort;
        return isSameSearch && isSameSort;
    }
}
exports.InMemoryDataSource = InMemoryDataSource;
//# sourceMappingURL=in-memory-data-source.js.map